import { compose } from "redux";
import isNil from "lodash/isNil";
import memoize from "lodash/memoize";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core";

import { BasePage } from "altus-ui-components";
import { ReceivedDataState } from "altus-datastate";

import {
  unloadWorkScheduleReport,
  workScheduleReportOnLoad,
} from "features/planner/report/report.actions";

import { getSummarizedDataStatesFromState } from "app/app.selectors";
import { ACTIONS } from "features/planner/report/report.constants";
import { generateWorkScheduleReportDates } from "utils/report.util";
import { ACTIONS as PLANNER_ACTIONS } from "features/planner/planner.constants";
import { getWorkScheduleReportFromState } from "features/planner/report/report.selectors";
import WorkScheduleReport from "features/planner/report/workSchedule/components/WorkScheduleReport";
import WorkScheduleReportDates from "features/planner/report/workSchedule/components/WorkScheduleReportDates";

class WorkScheduleReportContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.generateWorkScheduleReportDates = memoize(
      generateWorkScheduleReportDates,
    );
  }

  componentDidMount() {
    const { dispatchOnLoad } = this.props;
    dispatchOnLoad();
  }

  componentWillUnmount() {
    const { dispatchOnUnload } = this.props;
    dispatchOnUnload();
  }

  render() {
    const { classes, dataState, report, breadcrumb } = this.props;

    const reportType = report.getIn(["parameters", "reportType"]);

    if (isNil(reportType)) return null;

    const dates = this.generateWorkScheduleReportDates(report);

    return (
      <BasePage
        dataState={dataState}
        classes={{
          children: classes.basePageChildren,
        }}
      >
        <WorkScheduleReportDates
          dates={dates}
          title={breadcrumb}
          reportType={reportType}
        />
        <WorkScheduleReport
          dates={dates}
          report={report}
          reportType={reportType}
        />
      </BasePage>
    );
  }
}

const styles = theme => ({
  basePageChildren: {
    padding: 0,
    paddingTop: theme.spacing(5),
  },
});

WorkScheduleReportContainer.defaultProps = {
  dataState: ReceivedDataState,
};

export default compose(
  connect(
    state => ({
      report: getWorkScheduleReportFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_WORK_SCHEDULE_REPORT,
        PLANNER_ACTIONS.GET_EMPLOYEE_GROUPS,
        ACTIONS.DOWNLOAD_WORK_SCHEDULE_REPORT,
      ),
    }),
    {
      dispatchOnLoad: workScheduleReportOnLoad,
      dispatchOnUnload: unloadWorkScheduleReport,
    },
  ),
  withStyles(styles),
)(WorkScheduleReportContainer);
